/**
 * batch-69 samenstellen (FO-509 §E7) - hoor- en voelbare feedback bij een scan.
 *
 * Een scan in het magazijn gebeurt met handschoenen, met de telefoon in de hand
 * en de ogen op het schap: een geweigerde scan moet je HOREN en VOELEN, niet
 * alleen zien ("nooit stil"). Goed = één korte hoge piep + korte tril; fout =
 * twee lage tonen + lange tril. Werkt zonder audiobestanden (WebAudio) en valt
 * stil terug als de browser het niet kan of het geluid uit staat.
 */

let context: AudioContext | null = null

function audio(): AudioContext | null {
  if (typeof window === 'undefined') return null
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!Ctor) return null
  try {
    context ??= new Ctor()
    return context
  } catch {
    return null
  }
}

function toon(ctx: AudioContext, frequentie: number, startSec: number, duurSec: number): void {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = 'square'
  osc.frequency.value = frequentie
  gain.gain.setValueAtTime(0.08, ctx.currentTime + startSec)
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + startSec + duurSec)
  osc.connect(gain)
  gain.connect(ctx.destination)
  osc.start(ctx.currentTime + startSec)
  osc.stop(ctx.currentTime + startSec + duurSec + 0.02)
}

/** Speel de feedback voor een geslaagde (`true`) of geweigerde (`false`) scan. */
export function speelScanFeedback(ok: boolean): void {
  try {
    const ctx = audio()
    if (ctx) {
      if (ctx.state === 'suspended') void ctx.resume()
      if (ok) toon(ctx, 1320, 0, 0.09)
      else {
        toon(ctx, 220, 0, 0.18)
        toon(ctx, 180, 0.24, 0.24)
      }
    }
  } catch {
    // Geen geluid mogelijk: de visuele melding blijft.
  }
  try {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      navigator.vibrate(ok ? 60 : [200, 80, 200])
    }
  } catch {
    // Trillen niet ondersteund.
  }
}
